var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('server-side-paginated-table',{ref:"displayTable",attrs:{"fields":_vm.table_settings.fields,"api_url":_vm.table_settings.api_url,"delete_url":_vm.table_settings.delete_url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }